import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { LoadingBlock } from "@/components/AsyncState";

const AiConciergePage = lazy(() => import("@/pages/AiConciergePage"));

function ConciergeFallback() {
  return (
    <div className="px-4 pt-20">
      <LoadingBlock label="AI Night Concierge wird geladen…" />
    </div>
  );
}

export const Route = createFileRoute("/concierge")({
  head: () => ({
    meta: [
      { title: "AI Night Concierge · Pulse" },
      { name: "description", content: "Personalisierte Nightlife-Route mit Pulse AI." },
    ],
  }),
  component: () => (
    <Suspense fallback={<ConciergeFallback />}>
      <AiConciergePage />
    </Suspense>
  ),
});
